import React, { useEffect, memo, useState } from 'react';
import { Text, View, Pressable, ImageBackground, StyleSheet } from 'react-native';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { linkMyAccountWithOktaByGuidAndLogin, acceptInviteByGuid, resetState } from './slice';

import { AuthContainer } from '../auth_views';
import AccountLoginForm from './account_login';

const OktaAppContainer = memo((props) => {
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    let oktaLinkGuid = null;
    let oktaInviteGuid = null;
    const locationPath = window.location.pathname.toLowerCase();
    if (locationPath.toLowerCase().match('magic-link')) {
      oktaLinkGuid = new URLSearchParams(location.search).get('uuid');
    } else if (locationPath.startsWith('/invite/')) {
      oktaInviteGuid = locationPath.split('/invite/')[1];
    }

    if (oktaLinkGuid) {
      props.actions.linkMyAccountWithOktaByGuidAndLogin({ guid: oktaLinkGuid });
    } else if (oktaInviteGuid) {
      props.actions.acceptInviteByGuid({ guid: oktaInviteGuid });
    } else {
      setShowForm(true);
    }
    return () => {
      props.actions.resetState();
    };
  }, []);

  return (
    <AuthContainer autoAcceptAFTerms={true}>
      <View style={{ flexDirection: 'row', minHeight: '100%' }}>
        <Pressable style={{ flex: 1, minHeight: '100%' }} onPress={null}>
          <View style={{ flex: 1, minHeight: '100%' }}>
            <ImageBackground
              style={{ width: '100%', height: '100%' }}
              source={require('../../../../resources/auth_bg/web-bg-login.jpg')}
            />
          </View>
        </Pressable>
        <View style={{ flex: 1 }}>
          <View style={styles.paneWrapper}>
            <View style={{}}>{!!showForm ? <AccountLoginForm /> : null}</View>
          </View>
        </View>
      </View>
    </AuthContainer>
  );
});

const styles = StyleSheet.create({
  paneWrapper: {
    flex: 1,
    justifyContent: 'center',
    maxWidth: 400,
    width: '100%',
    marginHorizontal: 'auto',
  },
});

export default connect(
  (state) => ({
    authedToken: state.user.oktaAuthToken,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        linkMyAccountWithOktaByGuidAndLogin,
        acceptInviteByGuid,
        resetState,
      },
      dispatch
    ),
  })
)(OktaAppContainer);
